import type { FC } from "react";

import {
  COLLAPSABLE_CONTENT_VARIANT_CLASS_MAP,
  COLLAPSABLE_TRIGGER_ICON_VARIANT_MAP,
  COLLAPSABLE_TRIGGER_VARIANT_CLASS_MAP,
  COLLAPSIBLE_DEFAULTS,
  type TCollapsibleProps,
} from "@/ui/components/data-display/Collapsible/Collapsible.config";
import {
  CollapsibleContent,
} from "@/ui/components/data-display/Collapsible/CollapsibleContent";
import {
  CollapsibleRoot,
} from "@/ui/components/data-display/Collapsible/CollapsibleRoot";
import {
  CollapsibleTrigger,
} from "@/ui/components/data-display/Collapsible/CollapsibleTrigger";
import { cn } from "@/ui/lib/utils";
import { Icon } from "@/ui/components/primitives/Icon";
import { Inline } from "@/ui/components/layout";

export const Collapsible: FC<TCollapsibleProps> = (
  {
    children,
    className,
    contentClassName,
    "data-component": component = COLLAPSIBLE_DEFAULTS["data-component"],
    icon,
    triggerIcon,
    variant = COLLAPSIBLE_DEFAULTS.variant,
    title,
    triggerClassName,
    ...props
  },
) => {
  const resolvedTriggerIcon = triggerIcon ?? COLLAPSABLE_TRIGGER_ICON_VARIANT_MAP[variant];

  return (
    <CollapsibleRoot
      {...props}
      data-component={component}
      className={cn(
        className,
      )}
    >
      <CollapsibleTrigger
        triggerIcon={resolvedTriggerIcon}
        variant={variant}
        className={cn(
          triggerClassName,
          COLLAPSABLE_TRIGGER_VARIANT_CLASS_MAP[variant],
        )}
      >
        <Inline gap="2" align="center">
          { icon ? (
            <Icon icon={icon} size="md" />
          ) : null }
          { title }
        </Inline>
      </CollapsibleTrigger>
      <CollapsibleContent className={cn(
        contentClassName,
        COLLAPSABLE_CONTENT_VARIANT_CLASS_MAP[variant],
      )}>
        { children }
      </CollapsibleContent>
    </CollapsibleRoot>
  );
};

Collapsible.displayName = "Collapsible";
